import { Currency } from '@pancakeswap/sdk'
import { CurrencyLogo } from '@pancakeswap/widgets-internal'

interface DoubleCurrencyLogoProps {
  margin?: boolean
  size?: number
  currency0?: Currency
  currency1?: Currency
}

export default function DoubleCurrencyLogo({ currency0, currency1, size = 28 }: DoubleCurrencyLogoProps) {
  return (
    <div className={'flex items-center'}>
      {currency0 && <CurrencyLogo currency={currency0} size={`${size}px`} />}
      {currency1 && <CurrencyLogo currency={currency1} size={`${size}px`} />}
    </div>
  )
}
